import React, { Component } from 'react'
import { connect } from 'react-redux'
import NIHPopup from '../../UI/new-popup/NIHPopup'
import { setQRScannerPage, setDoorKeyValidationPopUp, setDoorKeyNotificaionPage, setLoadingMass } from '../../action/action'
import { EXIT, LayoutMaster } from '../../config/constant'
import { homeNaviation } from '../../config/layout2constant'
import { setCurrentHomePage, setGoHome } from '../../layout2.0/action/homeAction'
import $ from 'jquery'
import { HashRouter, Redirect } from 'react-router-dom';
import { QRSCANENABLE } from '../../config/constant'
import { getDefaultAnalyticsLabel } from '../../layout2.0/JS/utility'
import { sendAnalytics } from '../../action/homeAction'

class QRScannerPage extends Component {


    closeClick = () => {
        console.log("close click")
        this.props.setDoorKeyNotificaionPage(false);
        this.props.setDoorKeyValidationPopUp(false);
        this.props.setQRScannerPage(false);
        this.props.setLoadingMass(false);
        this.props.setGoHome(true)
        // this.props.setCurrentHomePage(homeNaviation[0]);

        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        this.props.sendAnalytics(
            this.props.guestDetail, 
            "Digital Door Key", 
            EXIT, 
            {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget",  "pageName": "QR SCANNER", "widgetSessionId": localStorage.getItem("doorKeySessionToken")},
            0, 
            this.props.guestIsLoggedIn,
            false
        );

        if (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken) {
            document.location.reload();
        }
        try {
            if (window.QRScanner) {
                window.QRScanner.destroy(function (status) {
                    console.log("Qr scanner destroyed",status);
                    // document.location.reload();
                    //alert(status)
                });
            }
        } catch (e) {
            console.log("error while colosing Scanner", e)
        }
    }

    componentDidMount(){
        $("html").attr('style', `background: transparent !important`);
        $("body").attr('style', `background: transparent !important`);
        $("#app-body").attr('style', `background: transparent !important`);
        $("#root").attr('style', `background: transparent !important`);
        $("#root").css("background-color", "transparent !important");
    }

    componentWillUnmount(){
        $("html").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("body").attr('style', `background: ${this.props.menuColor.backgroundColor} !important`);
        $("#app-body").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("#root").attr('style', `background: ${this.props.menuColor.backgroundColor}`);
        $("#root").css(`background: ${this.props.menuColor.backgroundColor}`);
    }


    render() {
        return (
            <div className='qr-scanner' style={{
                position: "absolute",
                width: "100%",
                height: "100%"
            }}>
                <div className='qr-desc' style={!LayoutMaster ? {
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                } : null}>
                    <div style={
                        // LayoutMaster ?
                        //     {
                        //         position: "absolute",
                        //         bottom: "4rem",
                        //         padding: "23px",
                        //         fontWeight: "bold",
                        //         color: "#fff",
                        //         fontSize: "17px",
                        //         textAlign: "center",
                        //         width: "100%"
                        //     }
                        //     :
                            {
                                position: "absolute",
                                // bottom: "4rem",
                                padding: "23px 0px",
                                fontWeight: "bold",
                                color: "#fff",
                                fontSize: "17px",
                                backgroundColor: '#000',
                                textAlign: "center",
                                width: "100%"
                            }
                    }>
                        Please scan the security QR code on the TV screen in your room to activate the digital key
                    </div>
                </div>
                <div
                    className="btn-close" 
                    style={{
                    position: "fixed",
                    bottom: "2rem",
                    width: "100%",
                    textAlign: "center"
                }}>
                    <button
                        style={{ borderRadius: "2rem", background: "#222211", width: "3.5rem", height: "3.5rem" }}
                        onClick={this.closeClick} className="center">
                        <i
                            style={{ color: "#fff" }}
                            class="fas fa-close"></i>
                    </button>
                </div>
                {
                    this.props.notInHotelPopup ?
                        <NIHPopup /> : ""
                }
                <div class={`qr-code`} >
                    <svg width="314" height="546" viewBox="0 0 314 546" fill="none" xmlns="http://www.w3.org/2000/svg"></svg>
                </div>
               
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        guestDetail: state.store.home.guestDetails,
        notInHotelPopup: state.store.notInHotelPopup,
        menuColor: state.store.home.MenuColor,
        CheckedInGuest: state.store.CheckedInGuest,
        installedAppName: state.store.installedAppName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        loginGuestDetails: state.store2.loginGuestDetails,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
    }
}
export default connect(
    mapStateToProps,
    {
        setQRScannerPage,
        setDoorKeyValidationPopUp,
        setDoorKeyNotificaionPage,
        setLoadingMass,
        setCurrentHomePage,
        setGoHome,
        sendAnalytics
    }
)(QRScannerPage);